import React, { FC } from 'react';
import { Upload } from 'antd';
import { AttachmentWithStatus, UPLOAD_STATUS } from '../../model/Attachment';

const ACCEPT = 'image/png, image/jpeg, application/pdf, .doc, .docx';
const TYPES = '.pdf .jpeg .png .doc .docx';

type Props = {
  id: string;
  file?: AttachmentWithStatus;
  // eslint-disable-next-line no-unused-vars
  onChange: (file: AttachmentWithStatus | {}) => void;
};

// The mockup's file field: looks like a text input, uploads to /files like the shared UploadForm.
const FileField: FC<Props> = ({ id, file, onChange }) => {
  const status = file?.status ?? UPLOAD_STATUS.DEFAULT;
  const isUploaded = status === UPLOAD_STATUS.DONE || status === UPLOAD_STATUS.SUCCESS;

  if (isUploaded) {
    return (
      <div className="filefield done">
        <span className="name">{`✓ ${file?.fileName}`}</span>
        <button type="button" className="btn-t" onClick={() => onChange({})}>Remove</button>
      </div>
    );
  }

  return (
    <>
      <Upload
        accept={ACCEPT}
        action={`${process.env.REACT_APP_API_BASE_URL}/files`}
        headers={{
          'X-API-KEY': process.env.REACT_APP_API_KEY as string,
          'Site-Id': process.env.REACT_APP_CURRENT_SITE_ID || '',
        }}
        showUploadList={false}
        disabled={status === UPLOAD_STATUS.UPLOADING}
        onChange={({ file: { status: next, response = {} } }) => onChange({ ...response, status: next })}
      >
        <button type="button" id={id} className="filefield">
          {status === UPLOAD_STATUS.UPLOADING ? 'Uploading…' : `Choose a file — ${TYPES}`}
        </button>
      </Upload>
      {status === UPLOAD_STATUS.ERROR && (
        <p className="err-msg">{`We could not upload that file. Please try again with a ${TYPES} file.`}</p>
      )}
    </>
  );
};

export default FileField;
